import * as types from './types';

const initialState = {
  filter: 'secondPeriod',
  filterStartPeriod: '',
  filterEndPeriod: ''
};

const appliedFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_APPLIED_FILTER:
      return { ...state, ...action.payload.newFilter };
    default:
      return state;
  }
};

export { appliedFilterReducer };
